import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { ChipModule } from 'primeng/chip';
import { Fieldset } from 'primeng/fieldset';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { AnimalModel } from '../../models/animal.model';
import { AnimalMediaCategoryModel } from '../../models/animal-media-category.model';
import { AnimalDocumentCategory } from '../../models/animal-document-category.enum';
import { DocumentUploadComponent } from '../upload/document-upload.component';

export interface DocumentFilterState {
  showUpload: boolean;
  showGenerated: boolean;
  selectedCategories: AnimalDocumentCategory[];
}

@Component({
  selector: 'app-documents-header',
  templateUrl: './documents-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule, FormsModule, TranslocoModule,
    ChipModule, Fieldset, ButtonModule, CheckboxModule, DocumentUploadComponent
  ]
})
export class DocumentsHeaderComponent {
  @Input() animal: AnimalModel | null = null;
  @Input() filter!: DocumentFilterState;
  @Input() categoryOptions: AnimalMediaCategoryModel[] = [];
  @Input() documents: any[] = [];
  @Input() isMultiSelectMode = false;

  @Output() multiSelectToggle = new EventEmitter<void>();
  @Output() filterChange = new EventEmitter<void>();
  @Output() documentsUploaded = new EventEmitter<number[]>();

  toggleCategoryFromString(value: string): void {
    const category = value as AnimalDocumentCategory;
    const selected = new Set(this.filter.selectedCategories);
    selected.has(category) ? selected.delete(category) : selected.add(category);
    this.filter.selectedCategories = Array.from(selected);
    this.filterChange.emit();
  }

  isSelectedCategory(value: string): boolean {
    return this.filter.selectedCategories.includes(value as AnimalDocumentCategory);
  }

  onToggleMultiSelectMode(): void {
    this.multiSelectToggle.emit();
  }
}
